import { ErrorScreen } from 'components/error-screen/ErrorScreen';
import { GradientCanvas } from 'components/gradient-canvas/GradientCanvas';
import { HomeButton } from 'components/home-button/HomeButton';

const ErrorScreenInvalidCampaign = () => {
  return (
    <>
      <GradientCanvas />
      <ErrorScreen>
        <div
          className={`container mb-8 max-w-[822px] text-center text-3xl font-semibold md:text-5xl`}
        >
          Live Display is not supported for this campaign.
        </div>
        <div>
          <HomeButton />
          <a
            href={`${import.meta.env.VITE_GLOBAL_APP_URL}/contact`}
            className={`mb-4 block w-full rounded-md border border-gray-300 bg-gray-50 px-[18px] py-[10px] text-center text-lg font-semibold shadow md:inline-block md:w-fit`}
          >
            Learn More
          </a>
        </div>
      </ErrorScreen>
    </>
  );
};

export { ErrorScreenInvalidCampaign };
